import { AUTHENTICATION } from "./authenticationConstants.js";

// -- AUTHENTICATION -- //

export const doLogin = (username, password) => {
  return {
    type: AUTHENTICATION.LOGIN.DO,
    payload: { username, password }
  };
};

export const doMarketplaceLogin = (username, password, provider, token) => {
  const payload = {
    marketplaceProvider: provider,
    marketplaceToken: decodeURIComponent(token), // encoded in the edge rewrite
    username: username,
    password: password
  };

  return {
    type: AUTHENTICATION.LOGIN.DO,
    payload: payload
  };
};

export const doRefresh = (refresh_token, success) => {
  return {
    type: AUTHENTICATION.REFRESH.DO,
    payload: { refresh_token },
    success
  };
};

export const doLogout = () => {
  return {
    type: AUTHENTICATION.LOGOUT.DO
  };
};

export const latestActivity = () => {
  return {
    type: AUTHENTICATION.LAST_ACTIVITY,
    payload: { lastActivity: Date.now() }
  };
};

// -- INACTIVITY WARNING -- // -- Not yet implemented

export const showInactivityWarning = () => {
  return {
    type: AUTHENTICATION.INACTIVITY_WARNING.DO
  };
};

export const dismissInactivityWarning = () => {
  return {
    type: AUTHENTICATION.INACTIVITY_WARNING.RESET
  };
};
